import {Component, Input} from '@angular/core';
import {WarningArrayItemDeletionComponent,} from '../../../../warning-array-item-deletion/warning-array-item-deletion.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AdvancedFormArray} from "@magieno/angular-advanced-forms";
import { AdvancedForm } from "@magieno/angular-advanced-forms";
import {IncomeTaxPersonalChildCampOptions,} from '../../../../../../../../../../../common/src/options/calculations/income-tax/personal/common/income-tax-personal-child-camp.options';
import {RrspOptions} from "../../../../../../../../../../../common/src/options/calculations/rrsp/rrsp.options";


@Component({
  selector: 'app-rrsp-personal-tax-child-camps-form',
  templateUrl: './rrsp-personal-tax-child-camps-form.component.html',
  styleUrls: ['./rrsp-personal-tax-child-camps-form.component.scss'],
  standalone: false,
})
export class RrspPersonalTaxChildCampsFormComponent {

  @Input()
  camps: AdvancedFormArray<IncomeTaxPersonalChildCampOptions>;
  @Input()
  form: AdvancedForm<RrspOptions>;

  constructor(public modalService: NgbModal) {

  }

  async removeCamp(campIndexToRemove: number) {
    const modal = this.modalService.open(WarningArrayItemDeletionComponent, {});
    (modal.componentInstance as WarningArrayItemDeletionComponent).objectDefinition = 'cette colonie de vacance';
    modal.closed.subscribe(async result => {
      if (result === true) {
        // Here we delete only in the form, not syncing the change to the server or else deleting could cause bad data to be sync.
        this.camps.delete(campIndexToRemove);

        return;
      }
    });

    return;
  }

  addCamp() {
    this.camps.appendNew();
  }
}
